import React, {useEffect, useState} from "react";
import moment from "moment";
import 'react-dates/initialize';
import UseWindowSize from "../../hooks/UseWindowSize";
import {FormGroup, Input, Label} from "reactstrap";
import {DateRangePicker} from "react-dates";
import {FilterSelection} from "../../types/filterSelection";
moment.locale("nl");

const renderCalendarInfo = (
    availableNights,
    selectedNights,
    setSelectedNights,
) => {
    return (
        <>
            <FormGroup className="datepicker-form-group">
                <Label for="nights" className="form-label form-label-nights">
                    Aantal nachten
                </Label>
                <Input defaultValue={selectedNights} type="select" name="nights" id="nights"
                       onChange={(e) => setSelectedNights(e.target.value)}>
                    {availableNights.map((nights) => (
                        <option key={nights} value={nights}>{`${nights} ${
                            nights == 1 ? "nacht" : "nachten"
                        }`}</option>
                    ))}
                </Input>
                <span><i
                    className="fas fa-circle date-legenda"/>Beschikbare aankomstdatums voor {selectedNights} nachten</span>
            </FormGroup>
        </>
    );
};

const isDayInBookableRange = (day, highlightedDates, selectedNights = 7) => {
    if (isDayHighlighted(day, highlightedDates)) {
        return true;
    }

    const arrivalDate = day.clone().subtract(selectedNights, 'day');
    if (isDayHighlighted(arrivalDate, highlightedDates)) {
        return true;
    }

    // Amount of previous dates to check
    const previousDayCount = Array.from(Array(selectedNights+1).keys());
    // previousDayCount.shift();
    const arrivalDates = previousDayCount.map(nights => {
        const dateString = day.clone().subtract(nights, 'day').format("YYYY-MM-DD");
        const date = highlightedDates.find((date) => {
            return date === dateString
        });

        if (date) {
            return true;
        }

        return false;
    });

    return arrivalDates.filter(isAvailable => isAvailable === true).length === 0;
};

const isDayHighlighted = (day, highlightedDates) => {
    const dateString = day.format("YYYY-MM-DD");

    const date = highlightedDates.find((date) => {
        return date === dateString;
    });

    if (date) {
        return true;
    }

    return false;
};

const isDayAvailable = (day, highlightedDates, selectedNights) => {
    const arrivalDate = day.clone().subtract(selectedNights, 'day');

    const dateString = day.format("YYYY-MM-DD");
    const arrivalDateString = arrivalDate.format("YYYY-MM-DD");

    const date = highlightedDates.find((date) => {
        return date === dateString || date === arrivalDateString;
    });

    if (date) {
        return true;
    }

    return false;
};

const getArrivalDates = (availability, nights) => {
    let today = moment().format("YYYY-MM-DD");
    return availability.availableDates
        .filter(date => {
            let found = date.availableNights.find(availableNight => parseInt(availableNight.nights) === parseInt(nights));

            return found !== undefined ? true : false;
        })
        .map((date) => {
            return date.date;
        })
        .filter((date) => date >= today);
};

interface DateRangePickerProps {
    availability: any,
    range: any
    setRange: any
    availableNights: any
    selectedNights: number
    setSelectedNights: any
    dateFocused: any
    setDateFocused: any
    searchSelection: FilterSelection,
}

export default function Index({
                                  availability,
                                  range,
                                  setRange,
                                  availableNights,
                                  selectedNights,
                                  setSelectedNights,
                                  dateFocused,
                                  setDateFocused,
                                  searchSelection
                              }: DateRangePickerProps) {
    const [startDateInvalid, setStartDateInvalid] = useState(false);
    const [highlightedDates, setHighlightedDates] = useState([]);
    const [nightsVariation, setNightsVariation] = React.useState(1);
    const [arrivalDateVariation, setArrivalDateVariation] = React.useState(1);
    const startDate = searchSelection.startDate ? moment(searchSelection.startDate) : null;
    const endDate = searchSelection.endDate ? moment(searchSelection.endDate) : null;
    const size = UseWindowSize();

    useEffect(() => {
        setHighlightedDates(getArrivalDates(availability, selectedNights));
    }, [availability, selectedNights]);

    useEffect(() => {
        setStartDateInvalid(false);

        // if (range.startDate && !range.endDate) {
        //     let updatedHighlightedDates = getDepartureDates(
        //         range.startDate,
        //         availability
        //     );
        //     updatedHighlightedDates.push(range.startDate.format("YYYY-MM-DD"));
        //     setHighlightedDates(updatedHighlightedDates);
        // }

        if (range.startDate && range.endDate) {
            setHighlightedDates(getArrivalDates(availability, selectedNights));
        }
    }, [range]);

    const onFocusChange = (dateFocused) => {
        if (dateFocused === null) {
            const fromDateInput = document.getElementById('fromDate');
            const toDateInput = document.getElementById('toDate');
            fromDateInput.blur();
            toDateInput.blur();
        }
        setDateFocused(dateFocused);
    }

    return (
        <div className="date-range-picker">
            <DateRangePicker
                anchorDirection="right"
                isDayBlocked={(day) => !isDayInBookableRange(day, highlightedDates, selectedNights)}
                isOutsideRange={(day) => isDayInBookableRange(day, highlightedDates, selectedNights) && !isDayAvailable(day, highlightedDates, selectedNights)}
                isDayHighlighted={(day) => isDayHighlighted(day, highlightedDates)}
                calendarInfoPosition="top"
                renderCalendarInfo={() =>
                    renderCalendarInfo(
                        availableNights,
                        selectedNights,
                        setSelectedNights,
                    )
                }
                displayFormat="DD MMM YYYY"
                startDatePlaceholderText="Aankomst"
                endDatePlaceholderText="Vertrek"
                hideKeyboardShortcutsPanel
                startDate={startDate}
                startDateId="fromDate"
                endDate={endDate}
                endDateId="toDate"
                endDateOffset={day => day.add(selectedNights, 'days')}
                block={true}
                onDatesChange={({startDate, endDate}) =>
                    setRange({startDate, endDate})
                }
                focusedInput={dateFocused}
                onFocusChange={(dateFocused) => onFocusChange(dateFocused)}
                orientation={size.width < 400 ? "vertical" : "horizontal"}
            />
        </div>
    );
}
